import Image from 'next/image'
import Link from 'next/link'

interface LogoProps {
  className?: string
  width?: number
  height?: number
}

export default function Logo({ className = "", width = 150, height = 150 }: LogoProps) {
  return (
    <Link href="/" className={`block ${className}`}>
      <Image
        src="/Guardian_Notary_Final.png"
        alt="Guardian Notary Services Logo"
        width={width}
        height={height}
        className={`${className} transition-transform duration-300 ease-in-out hover:scale-105`}
        priority
        quality={85}
        sizes="(max-width: 768px) 300px, (max-width: 1200px) 300px, 300px"
      />
    </Link>
  )
}
